import type { IExercise } from '../exercises';

export const FANJUE_EPISODE_14_MATERIALS: IExercise[] = [
  {
    "id": "course-20261008-fanjue-plan-14-01",
    "name": "仰卧杠铃臂屈伸",
    "bodyPart": "arms",
    "equipment": "barbell",
    "subCategory": "triceps",
    "tips": ["大臂保持垂直", "曲杆杠铃更护肘"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 45,
    "isBodyweight": false,
    "demoUrl": "/media/collections-20261008/demos/reviewed-1d5c24967575f4873f371a79.mp4",
    "videoUrl": "/media/collections-20261008/videos/fb8e67f442f19a719da2baec.mp4",
    "targetMuscles": ["肱三头肌"],
    "difficulty": "intermediate",
    "source": "焚诀计划 · 第14期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-fanjue-plan-14-02",
    "name": "单臂绳索臂屈伸",
    "bodyPart": "arms",
    "equipment": "cable",
    "subCategory": "triceps",
    "tips": ["单臂绳索下压", "侧重三头外侧头"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 45,
    "isBodyweight": false,
    "demoUrl": "/media/collections-20261008/demos/66677ca2fc07c137f17d392e.mp4",
    "videoUrl": "/media/collections-20261008/videos/8f80ac7e535eb3b11842f9a4.mp4",
    "targetMuscles": ["肱三头肌"],
    "difficulty": "beginner",
    "source": "焚诀计划 · 第14期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-fanjue-plan-14-03",
    "name": "直杆臂屈伸",
    "bodyPart": "arms",
    "equipment": "cable",
    "subCategory": "triceps",
    "tips": ["直杆绳索下压", "三头整体刺激"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 45,
    "isBodyweight": false,
    "demoUrl": "/media/collections-20261008/demos/68a2d26859775ba7d978c516.mp4",
    "videoUrl": "/media/collections-20261008/videos/299d518ab6776c38f1233e68.mp4",
    "targetMuscles": ["肱三头肌"],
    "difficulty": "beginner",
    "source": "焚诀计划 · 第14期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-fanjue-plan-14-04",
    "name": "俯身杠铃弯举",
    "bodyPart": "arms",
    "equipment": "barbell",
    "subCategory": "biceps",
    "tips": ["俯身位弯举", "二头峰值收缩"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 45,
    "isBodyweight": false,
    "targetMuscles": ["肱二头肌"],
    "difficulty": "intermediate",
    "source": "焚诀计划 · 第14期",
    "isWarmup": false,
    "isStretch": false,
    "mediaIssue": "新文件实际为坐姿绳索弯举，俯身杠铃弯举素材待补齐",
    "demoStatus": "pending",
  },
  {
    "id": "course-20261008-fanjue-plan-14-05",
    "name": "龙门架直杆弯举",
    "bodyPart": "arms",
    "equipment": "cable",
    "subCategory": "biceps",
    "tips": ["身体稳定，大臂贴身体两侧", "弯举时感受二头肌顶峰收缩，下放控制"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["肱二头肌"],
    "source": "焚诀计划 · 第14期",
    "demoUrl": "/media/collections-20261008/demos/01754bdcef3d1f268c3b8e7a.mp4",
    "videoUrl": "/media/collections-20261008/videos/d04d507d5973293cdbe4cc32.mp4",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-fanjue-plan-14-06",
    "name": "绳索锤式弯举",
    "bodyPart": "arms",
    "equipment": "cable",
    "subCategory": "biceps",
    "tips": ["锤式弯举", "肱肌+肱桡肌"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 45,
    "isBodyweight": false,
    "demoUrl": "/media/collections-20261008/demos/608707cbc7833ae6e01e060e.mp4",
    "videoUrl": "/media/collections-20261008/videos/6106177eaaecf67b21a0553e.mp4",
    "targetMuscles": ["肱二头肌"],
    "difficulty": "beginner",
    "source": "焚诀计划 · 第14期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
];
